export const experienceData = [
    {
        id: 1,
        company: 'Freelancer',
        jobtitle: 'Graphics and UI/UX Design',
        startYear: '2018',
        endYear: '2021'
    },
    {
        id: 2,
        company: 'Personal Projects and Skills',
        jobtitle: 'Web Developer',
        startYear: '2021',
        endYear: 'Present'
    }
]